import { isKnockout, isZoom } from '@ps/web-poker-tile-mappers';
import type React from 'react';

import type { Tournament } from '../../types/MTT';
import Tooltip from '../Tooltip/Tooltip';

import styles from './shared.scss';
import { getKnockoutIcon, getZoomIcon } from './utils';

type Props = Tournament;

const GameTypeStatusIcon: React.FC<Props> = ({
  tournGroup,
  tournFlags,
  tournFlags2,
  tournFlagsServInt,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  bounty,
  buyIn
}) => {
  const isZoomTournament = isZoom({
    tournFlags,
    tournFlags2,
    tournGroup,
    tournFlagsServInt
  });
  const isKOTournament = isKnockout({
    tournFlags,
    tournFlags2,
    tournGroup,
    tournFlagsServInt
  });
  const knockoutIcon = getKnockoutIcon(buyIn, bounty as number);
  const zoomIcon = getZoomIcon();

  return (
    <>
      {isZoomTournament && zoomIcon && (
        <Tooltip
          content={zoomIcon.TooltipContent}
          placement="bottom"
          arrowClassName={styles.tooltipArrow}
          tooltipClassName={styles.tooltip}
          refElementClassName={styles.tooltipWrapper}
        >
          {zoomIcon.Icon}
        </Tooltip>
      )}
      {isKOTournament && knockoutIcon && (
        <Tooltip
          content={knockoutIcon.TooltipContent}
          placement="bottom"
          arrowClassName={styles.tooltipArrow}
          tooltipClassName={styles.tooltip}
          refElementClassName={styles.tooltipWrapper}
        >
          {knockoutIcon.Icon}
        </Tooltip>
      )}
    </>
  );
};

export default GameTypeStatusIcon;
